import { Button } from '@mui/material'
import { withStyles } from '@mui/styles'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const StyledButton = withStyles({
    root: {
        minWidth: '70px',
        maxHeight: '35px',
        background: 'white',
        fontWeight: 500,
        border: '1px solid #EAEAEA',
        paddingTop: 8,
        paddingRight: 2,
        paddingLeft: 8,
        justifyContent: 'flex-end',
        paddingBottom: 8,
        "& > span": {
            fontSize:'14px',
            textTransform: 'none',
            overflow: 'visible'
        }
    },
})(Button);

export default function StyledPopup(props)
{
    const { value, open, drop, handleClick, style, className, ariaControls = "simple-menu", arrowColor = "#5A5A5A", display = 'inline'} = props;
    return (
    <StyledButton ref={drop} disableRipple aria-controls={ariaControls} className={className} style={style} aria-haspopup="true" onClick={(e) => handleClick(e)}>
        <span style={{ display: display, aligenItems: 'center', justifyContent: 'center', width: 'calc(100% - 16px)'}}>{value}</span>
        <ArrowDropDownIcon style={{userSelect: 'none', pointerEvents: 'none', fontSize:'2.25em', color: arrowColor, transform: open ? 'rotate(180deg)' : 'none'}}/>
    </StyledButton>
    );
}



